import L from "leaflet";
import { useMap } from "react-leaflet";

const ChangeMap = ({ latLongValue, maxZoom }) => {
  const map = useMap();
  if (latLongValue) {
    map.setView(new L.LatLng(latLongValue.lat, latLongValue.lng), maxZoom);
  }
  map.on("zoomend", () => {
    let zoomLevel = map.getZoom();
    let fieldlabelTooltip = document.getElementsByClassName("fieldlabel");
    toggleTooltip(fieldlabelTooltip, zoomLevel > 13, "d-none");
  });
  const toggleTooltip = (elements, condition, className) => {
    for (let i = 0; i < elements.length; i++) {
      if (condition) {
        elements[i].classList.remove(className);
      } else {
        elements[i].classList.add(className);
      }
    }
  };
  return null;
};

export default ChangeMap;
